import React, { useState } from 'react';
import { Cpu, Search, Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navLinks = [{
    name: 'Accelerators',
    href: '#'
  }, {
    name: 'Playground',
    href: '#'
  }, {
    name: 'Rankings',
    href: '#'
  }, {
    name: 'Enterprise',
    href: '#'
  }, {
    name: 'Pricing',
    href: '#'
  }, {
    name: 'Docs',
    href: '#'
  }];
  return <nav className="sticky top-0 z-50 w-full bg-gate-dark/80 backdrop-blur-md border-b border-gate-border/50" data-id="element-170">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-171">
        <div className="flex items-center justify-between h-16" data-id="element-172">
          {/* Logo */}
          <div className="flex items-center gap-2 flex-shrink-0" data-id="element-173">
            <div className="w-8 h-8 rounded-lg bg-gate-teal/10 flex items-center justify-center border border-gate-teal/20" data-id="element-174">
              <Cpu className="w-5 h-5 text-gate-teal" data-id="element-175" />
            </div>
            <span className="text-lg font-bold tracking-tight text-white" data-id="element-176">
              Open<span className="text-gate-teal" data-id="element-177">FPGA</span>
            </span>
          </div>

          {/* Desktop Search */}
          <div className="hidden md:flex flex-1 max-w-md mx-8" data-id="element-178">
            <div className="relative w-full group" data-id="element-179">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-180">
                <Search className="h-4 w-4 text-gate-text-muted group-focus-within:text-gate-teal transition-colors" data-id="element-181" />
              </div>
              <input type="text" className="block w-full pl-10 pr-10 py-1.5 border border-gate-border rounded-lg leading-5 bg-gate-surface text-gate-text-primary placeholder-gate-text-muted focus:outline-none focus:ring-1 focus:ring-gate-teal focus:border-gate-teal sm:text-sm transition-all" placeholder="Search models, providers, or docs..." data-id="element-182" />
              <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" data-id="element-183">
                <span className="text-gate-text-muted text-xs border border-gate-border rounded px-1.5 py-0.5 font-mono" data-id="element-184">
                  /
                </span>
              </div>
            </div>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-6" data-id="element-185">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-gate-text-secondary hover:text-white transition-colors" data-id="element-186">
                {link.name}
              </a>)}
            <a href="#" className="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-lg text-gate-dark bg-gate-teal hover:bg-gate-teal/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gate-teal transition-all shadow-[0_0_15px_-3px_rgba(0,212,170,0.4)]" data-id="element-187">
              Sign Up
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center" data-id="element-188">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="inline-flex items-center justify-center p-2 rounded-md text-gate-text-secondary hover:text-white hover:bg-gate-surface focus:outline-none" data-id="element-189">
              {isMobileMenuOpen ? <X className="block h-6 w-6" data-id="element-190" /> : <Menu className="block h-6 w-6" data-id="element-191" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-192">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-gate-surface border-b border-gate-border" data-id="element-193">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-194">
              <div className="px-3 pb-2" data-id="element-195">
                <div className="relative w-full" data-id="element-196">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-197">
                    <Search className="h-4 w-4 text-gate-text-muted" data-id="element-198" />
                  </div>
                  <input type="text" className="block w-full pl-10 pr-3 py-2 border border-gate-border rounded-lg leading-5 bg-gate-dark text-gate-text-primary placeholder-gate-text-muted focus:outline-none focus:ring-1 focus:ring-gate-teal focus:border-gate-teal sm:text-sm" placeholder="Search..." data-id="element-199" />
                </div>
              </div>
              {navLinks.map(link => <a key={link.name} href={link.href} className="block px-3 py-2 rounded-md text-base font-medium text-gate-text-secondary hover:text-white hover:bg-gate-dark" data-id="element-200">
                  {link.name}
                </a>)}
              <div className="px-3 pt-2" data-id="element-201">
                <a href="#" className="block w-full text-center px-4 py-2 border border-transparent text-base font-medium rounded-lg text-gate-dark bg-gate-teal hover:bg-gate-teal/90" data-id="element-202">
                  Sign Up
                </a>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}